import * as React from 'react';

import { cn } from '@/lib/cn';

export type DSCardProps = React.HTMLAttributes<HTMLDivElement>;

export const Card = React.forwardRef<HTMLDivElement, DSCardProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-[20px] border border-[rgba(255,255,255,0.05)] bg-[rgba(17,24,39,0.6)] p-6 text-white shadow-[0_20px_40px_rgba(0,0,0,0.4)] backdrop-blur-[20px] transition-all duration-base ease-out motion-safe:hover:shadow-[0_20px_40px_rgba(0,0,0,0.4),0_0_20px_rgba(139,92,246,0.35)]',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);

Card.displayName = 'DSCard';
